<div mat-dialog-title>
  <span>Select Ticket to Attach</span>
</div>

<mat-dialog-content>
  <div class="display-flex menu-content-search">
    <app-input
      class="w-100"
      [matFormCss]="'border-radius-partial-left'"
      [formControl]="searchControl"
      [attrPlaceholder]="'Search...'"
      [attrDisable]="false"
      [attrType]="'text'"
      [attrAutocomplete]="false"></app-input>

    <div class="search-icon display-flex align-items-center justify-content-center">
      <app-icon
        [svg]="EIcon.ICON_SEARCH"
        [iconColor]="EColorPalette.cGray7"
        [iconWidth]="18"
        [iconHeight]="18"></app-icon>
    </div>
  </div>

  <div class="modal-container">
    <ng-container *ngIf="filteredTickets?.length > 0; else noMatchingTickets">
      <div
        *ngFor="let ticket of filteredTickets"
        class="display-flex align-items-center grid-gap-8 ticket-item"
        (click)="onTicketSelect(ticket)">
        <app-avatar
          [containerCss]="'s-20'"
          [showMatTooltip]="true"
          [userInfo]="data.userMap?.get(ticket.assigneeId)?.value"></app-avatar>
        <app-fade-text [text]="ticket.title"></app-fade-text>
      </div>
    </ng-container>
    <ng-template #noMatchingTickets>
      <div class="display-flex align-items-center justify-content-center no-tickets">No matching tickets</div>
    </ng-template>
  </div>
</mat-dialog-content>

<mat-dialog-actions class="display-flex align-items-center justify-content-end">
  <button class="btn-close" mat-stroked-button color="primary" (click)="close()">Close</button>
</mat-dialog-actions>
